/**
 * DecreeLinesViewElement — kreator formatek: klocek palety reprezentujący siatkę
 * dekretacji Wn/Ma faktury (`decree_lines_view`, patrz `RecursiveFormRenderer`
 * PLACEHOLDER_TYPES).
 *
 * Mirror `DocumentItemsViewElement`/`AttachmentsViewElement` (patrz nagłówki tamtych
 * plików) — na REALNEJ stronie faktury ten typ będzie dispatchowany WYŁĄCZNIE przez
 * `contextRenderers['decree_lines_view']` (→ `DecreeLinesEditor`/`DecreeLinesSection`,
 * `apps/admin/src/components/documents/`) — ten rejestr obsługuje TYLKO podgląd w
 * canvasie buildera (mode='builder'), gdzie nie ma prawdziwego dokumentu do
 * wyświetlenia. Wpięcie na strony faktur (`PurchaseInvoiceDetail`/`SaleInvoiceDetail`)
 * jest osobnym krokiem — ten plik jest czysto addytywny (rejestracja typu elementu).
 *
 * `allowedModules` — TYLKO 2 moduły faktur (dekretacja nie dotyczy pozostałych 5 klas
 * dokumentu — umowy/pisma/handlowe/wewnętrzne/specjalne nie mają księgowań Wn/Ma).
 *
 * `render` jest wołany jak ZWYKŁA FUNKCJA (nie komponent) — patrz
 * `LayoutElementRegistry.render` — więc żaden hook nie może być wywołany
 * BEZPOŚREDNIO w jej ciele (ten sam powód co w `AttachmentsViewElement`):
 * `i18n.t` standalone zamiast `useTranslation`.
 */

import { BookOpen } from 'lucide-react';

import type { LayoutElementDefinition } from '@/components/fields/LayoutElementRegistry';
import i18n from '@/i18n';

export const DecreeLinesViewElement: LayoutElementDefinition = {
  type: 'decree_lines_view',
  category: 'tresc',
  isContainer: false,
  label: 'Dekretacja (Wn/Ma)',
  icon: 'BookOpen',
  allowedModules: ['purchase_invoices', 'sale_invoices'],
  defaultSettings: () => ({}),
  render: ({ element }) => (
    <div
      className="rounded-lg border border-dashed border-border-secondary bg-bg-secondary p-4 text-center"
      data-testid={`decree-lines-view-element-${element.id}`}
      data-element-type="decree_lines_view"
    >
      <BookOpen className="mx-auto h-5 w-5 text-text-muted" aria-hidden="true" />
      <p className="mt-1 text-xs font-medium text-text-secondary">
        {i18n.t('tenant.documents.decree.paletteLabel', {
          defaultValue: 'Dekretacja (Wn/Ma)',
        })}
      </p>
    </div>
  ),
};
